@if (!(['all_sheetFolders', 'deleted', 'archived', 'templates'] | includesBy: sidebarFilterKey)) {
  <app-context-menu-item
    title="Add new workbook"
    >
    <app-sheet-quick-form
      class="quick-form"
      [sheet]="stitchItem"
      [inline]="true"
      (close)="handleClose()"
      (more)="handleMore($event)"
      />
    </app-context-menu-item>
  }

  @if (!(['all_sheets', 'deleted', 'archived', 'templates'] | includesBy: sidebarFilterKey)) {
    <app-context-menu-item
      title="Add new folder"
      >
      <app-sheet-folder-quick-form
        class="quick-form"
        [sheetFolder]="containerStitchItem"
        [inline]="true"
        (close)="handleClose()"
        />
      </app-context-menu-item>
    }

    @if (!(['all_sheets', 'deleted', 'archived', 'all_sheetFolders', 'templates'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'flagged') {
      <app-context-menu-item
        title="Unflag all"
        [close]="true"
        (execute)="unFlagAll()"
        />
    }

    @if (sidebarFilterKey === 'followed') {
      <app-context-menu-item
        [title]="followUpWording.removeAllFollowUps()"
        [close]="true"
        (execute)="unFollowAll()"
        />
    }

    @if (sidebarFilterKey === 'snoozed') {
      <app-context-menu-item
        title="Unsnooze all"
        [close]="true"
        (execute)="unSnoozeAll()"
        />
    }

    @if ((['followed', 'snoozed', 'flagged'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'archived') {
      <app-context-menu-item
        title="Delete all"
        [close]="true"
        (execute)="deleteAll()"
        />
    }

    @if (sidebarFilterKey === 'deleted') {
      <app-context-menu-item
        title="Empty trash"
        [disabled]="!((purgeTenantId | appCanPurge: 'Sheet') && (purgeTenantId | appCanPurge: 'SheetFolder'))"
        [note]="PURGE_REFUSED_REASON"
        [close]="true"
        (execute)="emptyTrash()"
        />
    }

    @if (!(['deleted', 'archived'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-item
        title="Settings"
        [close]="true"
        (execute)="openSettings()"
        />
    }
